import { ErrorTextProps } from "./types"
import React from "react"
import { ErrorTextCore } from "./core"

const ErrorText: React.FC<ErrorTextProps> = (props) => {
  return <ErrorTextCore {...props} />
}

export default ErrorText
